<template>
  <div class="recruiting-performance-departments">
    <ul v-if="table.length === 0" class="departments-list">
      <DpplListItem>
        <template #left>
          <div class="d-flex justify-start align-center ml-8">
            No results found.
          </div>
        </template>
      </DpplListItem>
    </ul>
    <ul v-else aria-label="Departments" class="departments-list">
      <DpplListItem
        v-for="({
          id,
          department_id,
          tag_id,
          label,
          days_published,
          open,
          added,
          removed,
          score,
        }) in table"
        :key="id"
        class="list-item"
        @click="$emit('filterDepartment', { department_id, tag_id })"
      >
        <template #left>
          <div class="row-title">
            <p class="text-h2">
              {{ label }}
            </p>
          </div>
        </template>
        <template #right>
          <RecruitingPerformanceCell
            label="Avg. Days Live"
            :value="days_published === null ? 'N/A' : days_published"
          />
          <RecruitingPerformanceCell
            label="Jobs Open"
            :value="open"
          />
          <RecruitingPerformanceCell
            label="Jobs Added"
            :value="added"
          />
          <RecruitingPerformanceCell
            label="Jobs Removed"
            :value="removed"
          />
          <RecruitingPerformanceCell
            label="Average Score"
            :color="getColor(Math.floor(score))"
            :value="Math.floor(score)"
          />
        </template>
      </DpplListItem>
    </ul>
  </div>
</template>

<script>
import { colorMap } from '@/helpers/formatters';
import DpplListItem from '@/components/datapeople/DpplListItem.vue';
import RecruitingPerformanceCell from '@/components/insights/OperationalInsights/RecruitingPerformance/RecruitingPerformanceCell.vue';
import { useColors } from '@/composables/colors';

export default {
  name: 'RecruitingPerformanceDepartments',
  components: {
    DpplListItem,
    RecruitingPerformanceCell,
  },
  props: {
    type: { type: String, default: '' },
    table: { type: Array, default: () => [] },
  },
  emits: ['filterDepartment'],
  setup() {
    const {
      brandPrimary,
      grey800,
      red700,
      orange700,
      blue700,
      green700,
    } = useColors();

    return {
      brandPrimary,
      colorsToMap: {
        grey800,
        red700,
        orange700,
        blue700,
        green700,
      },
    };
  },

  methods: {
    getColor(score) {
      if (!score || score === '0') {
        return this.brandPrimary;
      }
      return colorMap(score, this.colorsToMap);
    },
  },
};
</script>

<style scoped lang="less">
.row-title {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 12px;
  font-weight: 500;
}

.list-item:hover .row-title {
  text-decoration: underline;
}

.recruiting-performance-departments {
  border: 1px solid rgb(var(--v-theme-strokeDefault));
  border-radius: 8px;

  :deep(.dppl-list-item):last-child {
    border-bottom: none;
  }
}

.departments-list {
  border-radius: 8px;
}
</style>
